import React from "react";
import { ClipboardList, CalendarCheck, Banknote, Landmark, Wallet, XCircle, Check } from "lucide-react";

export const STAGES = [
  { key: "requested", label: "Requested", icon: ClipboardList },
  { key: "scheduled", label: "Scheduled", icon: CalendarCheck },
  { key: "picked_up", label: "Picked Up", icon: Banknote },
  { key: "deposited", label: "Deposited", icon: Landmark },
  { key: "credited", label: "Credited", icon: Wallet },
];

export const STATUS_STYLE = {
  requested: "bg-slate-100 text-slate-700",
  scheduled: "bg-blue-100 text-blue-700",
  picked_up: "bg-orange-100 text-orange-700",
  deposited: "bg-indigo-100 text-indigo-700",
  credited: "bg-green-100 text-green-700",
  cancelled: "bg-red-100 text-red-600",
  rejected: "bg-red-100 text-red-600",
};

export const StatusPill = ({ status, testId }) => (
  <span data-testid={testId} className={`px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wide ${STATUS_STYLE[status] || "bg-slate-100"}`}>
    {status.replace("_", " ")}
  </span>
);

export const PickupTracker = ({ pickup }) => {
  const stopped = pickup.status === "cancelled" || pickup.status === "rejected";
  const current = STAGES.findIndex((s) => s.key === pickup.status);
  const reached = stopped ? (pickup.timeline || []).filter((t) => STAGES.some((s) => s.key === t.status)).length - 1 : current;
  return (
    <div data-testid={`pickup-tracker-${pickup.id}`}>
      <div className="flex items-center">
        {STAGES.map((s, i) => {
          const done = i <= reached;
          const Icon = done && i < reached ? Check : s.icon;
          return (
            <React.Fragment key={s.key}>
              <div className="flex flex-col items-center gap-1.5 min-w-[56px]">
                <div className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors ${done ? "bg-[#0D1B2A] text-white" : "bg-slate-100 text-slate-400"} ${i === reached && !stopped ? "ring-4 ring-[#06B6D4]/30" : ""}`}>
                  <Icon size={16} />
                </div>
                <span className={`text-[10px] font-semibold text-center ${done ? "text-[#0D1B2A]" : "text-slate-400"}`}>{s.label}</span>
              </div>
              {i < STAGES.length - 1 && <div className={`flex-1 h-0.5 mb-5 ${i < reached ? "bg-[#0D1B2A]" : "bg-slate-200"}`} />}
            </React.Fragment>
          );
        })}
      </div>
      {stopped && (
        <div className="mt-3 flex items-center gap-2 text-xs font-semibold text-red-600"><XCircle size={14} /> This request was {pickup.status}.</div>
      )}
    </div>
  );
};
